/*
Template Name: Admin Template
Author: Wrappixel

File: js
*/
$(function () {
    "use strict";
    var url = window.location + "";
    url = url.split(/[?#]/)[0];
    var path = url.replace(window.location.protocol + "//" + window.location.host + "/", "");
    path = path.split(/[?#]/)[0];
    if (path.length == 0) path = "home";

    var element = $("ul#sidebarnav a").filter(function () {
        if (this.dataset.parentFor) {
            let parentFor = JSON.parse(this.dataset.parentFor);
            // `path` je bez úvodního lomítka, takže substring "vize" chytí i "provize".
            // Token uvozený "=" proto znamená shodu na celou cestu.
            if (parentFor.some((v) => (v.charAt(0) === "=" ? path === v.slice(1) : path.includes(v)))) return true;
        }
        return this.href === url || this.href === path;
    });
    element.parentsUntil(".sidebar-nav").each(function (index) {
        if ($(this).is("li") && $(this).children("a").length !== 0) {
            $(this).children("a").addClass("active");
            $(this).parent("ul#sidebarnav").length === 0 ? $(this).addClass("active") : $(this).addClass("selected");
        } else if (!$(this).is("ul") && $(this).children("a").length === 0) {
            $(this).addClass("selected");
        } else if ($(this).is("ul")) {
            $(this).addClass("in");
        }
    });

    element.addClass("active");
    $("#sidebarnav a").on("click", function (e) {
        if (!$(this).hasClass("active")) {
            // hide any open menus and remove all other classes
            $("ul", $(this).parents("ul:first")).removeClass("in");

            // open our new menu and add the open class
            $(this).next("ul").addClass("in");
            $(this).attr("aria-expanded", "true");
            $(this).addClass("active");
        } else {
            $(this).removeClass("active");
            $(this).parents("ul:first").removeClass("active");
            $(this).attr("aria-expanded", "false");
            $(this).next("ul").removeClass("in");
        }
    });
    // Rodiče podmenu mají zástupný href a klik je jen rozbalí; kdyby některý dostal opravdový
    // odkaz, prohlížeč by na něj přešel.
    $("#sidebarnav >li >a.has-arrow").on("click", function (e) {
        var href = $(this).attr("href");
        if (!href || href === "#" || href.indexOf("javascript:") === 0) {
            e.preventDefault();
        }
    });

    // Auto scroll to the active nav
    if ($(window).width() > 768 || window.Touch) {
        $(".scroll-sidebar").animate(
            {
            },
            500
        );
    }
});
